import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  PartnerTransferCase,
  TransferCaseData,
  TransferCaseStatusData,
  Customer,
  Fitter,
  Responsible,
  CaseOverviewCase,
  TransferCaseInputCase
} from './transfer-models';
import * as api from '../shared/api/apihandler';
import { CaseDetails } from "app/shared-html-components/details/details.component";

export class TransferCaseCommonFunction {
  constructor(private http: HttpClient) { }
  // variables
  intergrationId = localStorage.getItem('integration');
  companyInfo;
  responsibles;
  companyUsers;
  fitters;

  eKompletOrderGroup() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.get(api.jubloApi + 'api/Outbox/Ekomplet/OrderGroup', { headers })
  }

  eKompletDepartment() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.get(api.jubloApi + 'api/Outbox/Ekomplet/Department', { headers })
  }

  eKompletDimensionCarrier() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.get(api.jubloApi + 'api/Outbox/Ekomplet/DimensionCarrier', { headers })
  }

  eKompletPriceGroup() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.get(api.jubloApi + 'api/Outbox/Ekomplet/PriceGroup', { headers })
  }

  eKompletProfitGroup() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.get(api.jubloApi + 'api/Outbox/Ekomplet/ProfitGroup', { headers })
  }

  eKompletPurposes() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.get(api.jubloApi + 'api/Outbox/Ekomplet/DimensionPurpose', { headers })
  }

  eKompletTeamLeader() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.get(api.jubloApi + 'api/Outbox/Ekomplet/TeamLeader', { headers })
  }

  getOSStatus() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.get(api.jubloApi + 'api/Minuba/GetOSStatus', { headers })
  }

  getOSDepartments() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.get(api.jubloApi + 'api/Minuba/GetOSDepartments', { headers })
  }

  getOSEconomyGroups() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.get(api.jubloApi + 'api/Minuba/GetOSeconomySystemGroups', { headers })
  }

  getOSCustomerGroups() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.get(api.jubloApi + 'api/Minuba/GetOSCustomerGroups', { headers })
  }

  getOSTypes() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.get(api.jubloApi + 'api/Minuba/GetOSTypes', { headers })
  }

  getPartnerCase(transferId: string) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.get<PartnerTransferCase>(api.jubloApi + 'api/Website/CaseTransfer/CaseTransfer/' + transferId, { headers })

  }

  transferCase(c: TransferCaseData) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.post(api.jubloApi + 'api/Minuba/CreateCase', c, { headers })
  }

  acceptCaseTransfer(transferId, data: TransferCaseStatusData) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.put(api.jubloApi + 'api/Website/CaseTransfer/CaseTransferStatus/' + transferId + '/36249264-3ac4-446b-a85e-81220ebfd518', data, { headers })
  }

  messageToCase(caseId, description, title) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.post(api.jubloApi + 'api/Website/Case/MessageFromTransfer', {
      caseId: caseId,
      title: title,
      description: description
    }, { headers })
  }

  changeResponsible(caseId, responsibleId) {
    console.log(responsibleId)
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.patch(api.jubloApi + 'api/Website/Case/ChangeResponsible/' + caseId + '/' + responsibleId, {}, { headers }).subscribe(
      () => { }
    )
  }

  addressToPartnerCaseAddress(addressControl, caseData) {
    let a = addressControl;
    let c = caseData;
    c.customer = {
      id: a.customer.customerId,
      name: a.customer.customerName,
      address: a.customer.customerAddress,
      zipCode: a.customer.customerZipCode,
      city: a.customer.customerCity,
      email: a.customer.customerMail,
      mobile: a.customer.customerMobile,
      phone: a.customer.customerPhone
    }
    c.delivery = {
      id: a.delivery.customerId,
      name: a.delivery.customerName,
      address: a.delivery.customerAddress,
      zipCode: a.delivery.customerZipCode,
      city: a.delivery.customerCity,
      email: a.delivery.customerMail,
      mobile: a.delivery.customerMobile,
      phone: a.delivery.customerPhone
    }
    c.contact = {
      id: a.contact.id,
      name: a.contact.name,
      address: a.contact.address,
      zipCode: a.contact.zipCode,
      city: a.contact.city,
      email: a.contact.email,
      phone: a.contact.phone,
      mobile: a.contact.mobile
    }
    return caseData
  }

  rejectCase(transferId: string) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.put(api.jubloApi + 'api/Website/CaseTransfer/CaseTransferStatus/' + transferId + '/789e1326-6655-4e98-bcd1-41c527e32d93',
      {}, { headers })
  }

  cancelCase(caseId: string) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.patch(api.jubloApi + 'api/Website/Case/' + caseId + '/Set/Status/99bc09b6-b7f7-46c0-a40b-5dfc27ec9cf0',
      {}, { headers })
  }

  editCase(caseId, title, description, requisitionNumber, reference, internalNote) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.put(api.jubloApi + 'api/Website/Case/EditCase/' + caseId, {
      title: !!title ? title : null,
      description: !!description ? description : null,
      requisitionNumber: !!requisitionNumber ? requisitionNumber : null,
      vorRef: !!reference ? reference : null,
      internalNote: !!internalNote ? internalNote : null
    }, { headers })
  }

  /*
    Jublo validation  
  */
  inputToOutputCase(t: TransferCaseInputCase): TransferCaseStatusData {
    let cu = {
      customerId: t.customer.id,
      customerName: t.customer.name,
      customerAddress: t.customer.address,
      customerZipCode: t.customer.zipCode,
      customerCity: t.customer.city,
      customerTelephone: t.customer.phone,
      customerFax: null,
      customerEmail: t.customer.email,
      customerMobile: t.customer.mobile,
      invoiceName: t.invoice.name,
      invoiceAddress: t.invoice.address,
      invoiceZipCode: t.invoice.zipCode,
      invoiceCity: t.invoice.city,
      invoiceTelephone: t.invoice.phone,
      invoiceFax: null,
      invoiceEmail: t.invoice.email,
      invoiceMobile: t.invoice.mobile,
      cvr: null,
      ean: null,
      customerRemarks: null,
      customerAttention: null
    };
    let dev = t.delivery;
    let de = !!dev ? {
      skip: !dev.name && !dev.address && !dev.zipCode && !dev.city && !dev.phone && !dev.email,
      name: dev.name,
      address: dev.address,
      zipCode: dev.zipCode,
      city: dev.city,
      telephone: dev.phone,
      mobile: dev.phone,
      email: dev.email,
      att: null,
      ean: null
    } : { skip: true, name: null, address: null, zipCode: null, city: null, telephone: null, mobile: null, att: null, ean: null, email: null };
    let cov = t.contact;
    console.log(t, cov)
    let co = !!cov ? {
      skip: !cov.name && !cov.address && !cov.zipCode && !cov.city && !cov.phone && !cov.email,
      name: cov.name,
      address: cov.address,
      zipCode: cov.zipCode,
      city: cov.city,
      telephone: cov.phone,
      mobile: cov.phone,
      email: cov.email,
      att: null,
      ean: null
    } : { skip: true, name: null, address: null, zipCode: null, city: null, telephone: null, mobile: null, att: null, ean: null, email: null };
    return {
      title: t.title,
      description: t.description,
      disableNotifications: t.disableNotifications,
      responsibleId: t.responsible,
      requisitionNumber: t.requisitionNumber,
      caseNumber: t.caseNumber,
      reference: t.reference,
      caseChannel: t.caseChannel,
      caseTypeId: t.caseType,
      files: [], // all files should be transferred. Deprecated
      customer: cu,
      delivery: de,
      contact: co
    }
  }

}

export class TransferCaseObjectTranslates {
  async outboxCaseToTransferCase(c: CaseOverviewCase): Promise<TransferCaseInputCase> {
    let d = c.deliveryAddress;
    let cus = {
      id: c.customer.customerId,
      name: c.customer.name,
      address: c.customer.address,
      zipCode: c.customer.zipCode,
      city: c.customer.city,
      phone: c.customer.phone,
      email: c.customer.email,
      mobile: c.customer.phone
    }
    let del = {
      id: d.customerId,
      name: d.name,
      address: d.address,
      zipCode: d.zipCode,
      city: d.city,
      phone: d.phone,
      mobile: d.phone,
      email: d.email,
      att: null,
      ean: null
    }
    // let f = !!c.files ? c.files.map(x => { 
    //   return {
    //     fileId : null,
    //     fileAccessId : null,
    //     path : null
    //   }
    //  }) : [];
    return {
      caseId: c.caseId,
      department: c.departmentId,
      internalNote: c.internalNote,
      fitter: c.fitter.fitterId,
      transferId: c.transferId,
      transferType: c.transferTypeId,
      title: c.title,
      description: c.description,
      responsible: c.responsible.responsibleId,
      customer: cus,
      invoice: null,
      delivery: del,
      contact: null,
      requisitionNumber: c.requisitionNumber,
      disableNotifications: !c.disableNotifications,
      caseNumber: c.caseNumber,
      caseChannel: !!c.caseChannel ? c.caseChannel.name : null,
      caseType: c.caseType.id,
      reference: c.vorRef,
      files: null
    }
  }

  async caseDetailsCaseToTransferCase(c: CaseDetails): Promise<TransferCaseInputCase> {
    let d = c.deliveryAddress;
    let cus = {
      id: c.customer.customerId,
      name: c.customer.name,
      address: c.customer.address,
      zipCode: c.customer.zipCode,
      city: c.customer.city,
      phone: c.customer.phone,
      email: c.customer.email,
      mobile: c.customer.phone
    }
    let del = {
      id: d.id,
      name: d.name,
      address: d.address,
      zipCode: d.zipCode,
      city: d.city,
      phone: d.phone,
      mobile: d.phone,
      email: d.email,
      att: null,
      ean: null
    }
    let f = !!c.files ? c.files.map(x => {
      return {
        fileId: null,
        fileAccessId: null,
        path: null
      }
    }) : [];
    return {
      caseId: c.caseId,
      department: c.departmentId,
      internalNote: c.internalNote,
      fitter: c.fitter.fitterId,
      transferId: c.transferId,
      transferType: c.transferTypeId,
      title: c.title,
      description: c.description,
      responsible: c.responsible.responsibleId,
      customer: cus,
      invoice: null,
      delivery: del,
      contact: null,
      requisitionNumber: c.requisitionNumber,
      disableNotifications: !c.disableNotifications,
      caseNumber: c.caseNumber,
      caseChannel: !!c.caseChannel ? c.caseChannel.name : null,
      caseType: c.caseType.id,
      reference: c.vorRef,
      files: f
    }
  }
}
